import React from 'react';
import {
	Form, Empty, Checkbox, Button, message, Col, Row, Input, Select, DatePicker, Space, Card, Radio, Spin,
	Descriptions, Divider
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, CloseOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { APIService } from '../../../../services/projectManager/api';
import { CalendarTimeService } from '../../../../services/calendar/calendar.tool.service.js';
import { __waterDocumentSvg } from '../../../../lib/waterMarking.js';
import Replacement from './Replacement.jsx'
import 'antd/dist/antd.css';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';


class TAInfo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.data.isEdit,
			closeType: this.props.info ? this.props.info : null,
			loading: false
		};

		// this.formRef = React.createRef();
	}

	componentDidMount() {
		const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
		__waterDocumentSvg({
			container: document.getElementById('ProjectManager-TA'),
			// content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
			width: '700px',
			height: '550px',
			opacity: '0.1',
			fontSize: '26px',
			zIndex: 1000
		})
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		};
	}

	onFinish = (formsValue) => {
		console.log('formsValue', formsValue);
		this.setState((prev, props) => {
			return { loading: true }
		})
		const date_list = ['f106', 'f111', 'f152', 'f153'];
		let values = {};
		Object.keys(formsValue).map(field => {
			if (formsValue[field] != undefined) {
				if (date_list.includes(field)) {
					values[field] = formsValue[field].format('YYYY-MM-DD')
				} else {
					values[field] = formsValue[field]
				}
			}
		})
		let param = {
			data: JSON.stringify(values),
		};
		APIService.SaveProject(param).then(res => {
			if (res.success) {
				message.success('提交申赎交易及TA清算规则信息成功!');
			} else {
				message.error(res.error)
			}
			this.setState((prev, props) => {
				return { loading: false }
			})
		}).catch(err => {
			console.log('提交申赎交易及TA清算规则信息 Error', err);
			this.setState((prev, props) => {
				return { loding: false }
			})
		})
	};

	changeCloseType = (e) => {
		console.log('closeType', e.target.value)
		this.setState((prev, props) => {
			return { closeType: e.target.value }
		});
	}

	// from置空
	eliminate = (f) => {
		this.props.formRef.current.resetFields([f]);
	}

	render() {
		const { isEdit, formData } = this.props.data;
		const { closeType, loading } = this.state;
		return (
			<div id="ProjectManager-TA">
				<Spin
					size="large"
					spinning={loading}
				>
					{/*

				<Form 
					ref={this.formRef}
					name="TA"
					labelAlign="left"
					layout="inline"
					onFinish={this.onFinish}
					initialValues={formData}
				>
					<Form.Item name="_id" hidden={true}><Input /></Form.Item>
				*/}
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<span>基本信息</span>}
								id="jbxx_card"
							>
								<Row gutter={[8, 8]}>
									<Col span={24}>
										<Descriptions
											size="middle"
											column={2}
											bordered
											contentStyle={{ minwidth: 500 }}
										>
											<Descriptions.Item
												span={2}
												label="开放日允许交易类型"
											>
												<div style={{ display: 'flex' }}>
													<Form.Item
														name="f99"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="申购">申购</Radio.Button>
															<Radio.Button value="赎回">赎回</Radio.Button>
															<Radio.Button value="全部">全部</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f99"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												span={2}
												label="开放期交易受理时间(T-N)"
											>
												<Row>
													<Col span={8}>
														<Form.Item
															name="f97"
															label="申购申请期（T-N）"
														>
															<Input 
																disabled={!isEdit} 
																bordered={false} 
																placeholder="请填写申购申请期（T-N）"
															/>
														</Form.Item>
													</Col>
													<Col span={8}>
														<Form.Item
															name="f98"
															label="赎回申请期（T-N）"
															placeholder="请填写申购申请期（T-N）"
														>
															<Input 
																disabled={!isEdit} 
																bordered={false} 
																placeholder="请填写申购申请期（T-N）"
															/>
														</Form.Item>
													</Col>
													{/* <Col span={8}>
														<Form.Item
															name="f107"
															label="打款截止时间"
														>
															<DatePicker
																disabled={!isEdit}
																locale={locale}
																style={{width: '100%'}}
																getPopupContainer={() => document.getElementById('jbxx_card')}
															/>
														</Form.Item>
													</Col> */}
												</Row>
											</Descriptions.Item>

											<Descriptions.Item
												span={2}
												label="开放日自动强赎"
											>
												<div style={{ display: 'flex' }}>
													<Form.Item
														name="f100"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f100"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="开放期净值归1"
											>
												<div style={{ display: 'flex' }}>
													<Form.Item
														name="f108"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f108"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="遇节假日处理方式"
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f101"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="顺延">顺延</Radio.Button>
															<Radio.Button value="提前">提前</Radio.Button>
															<Radio.Button value="照常开放">照常开放</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f101"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="首个开放日"
											>
												<Form.Item
													name="f102"
												>
													<DatePicker
														disabled={!isEdit}
														locale={locale}
														style={{ width: '100%' }}
														getPopupContainer={() => document.getElementById('jbxx_card')}
													/>
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="认购期利息处理方式"
											>
												<Form.Item
													name="f182"
												>
													<Input
														disabled={!isEdit}
														bordered={false}
													/>
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												label="金额尾数处理方式"
											>
												<Row gutter={[5, 5]}>
													<Col span={24}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f104"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="舍位">舍位</Radio.Button>
																	<Radio.Button value="四舍五入">四舍五入</Radio.Button>
																	<Radio.Button value="进位">进位</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f104"}/>
															}
														</div>
														<Divider style={{ margin: "5px 0 0 0" }} />
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f103"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="精确到分">精确到分</Radio.Button>
																	<Radio.Button value="精确到元">精确到元</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f103"}/>
															}
														</div>
													</Col>
												</Row>
											</Descriptions.Item>
											<Descriptions.Item
												label="份额尾数处理方式"
											>
												<Row gutter={[5, 5]}>
													<Col span={24}>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f105"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="舍位">舍位</Radio.Button>
																	<Radio.Button value="四舍五入">四舍五入</Radio.Button>
																	<Radio.Button value="进位">进位</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f105"}/>
															}
														</div>
														<Divider style={{ margin: "5px 0 0 0" }} />
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f106"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="精度到小数点后两位">精度到小数点后两位</Radio.Button>
																	<Radio.Button value="精度到个位">精度到个位</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f106"}/>
															}
														</div>
													</Col>
												</Row>
											</Descriptions.Item>
											{/* <Descriptions.Item
												label="是否电子合同"
											>
												<Form.Item
													name="f109"
												>
													<Radio.Group  buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="是">是</Radio.Button>
														<Radio.Button value="否">否</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Descriptions.Item> */}
											<Descriptions.Item
												label="分红方式"
											>
												<div className="highlight">
													<Form.Item
														name="f188"
													>
														<Select
															mode="multiple"
															disabled={!isEdit}
															placeholder={"点击选择分红方式"}
															getPopupContainer={triggerNode => triggerNode.parentNode}
														>
															<Select.Option value="不涉及">不涉及</Select.Option>
															<Select.Option value="现金分红">现金分红</Select.Option>
															<Select.Option value="红利再投">红利再投</Select.Option>
														</Select>
													</Form.Item>
												</div>
											</Descriptions.Item>
											{/* <Descriptions.Item
												label="存续份额为零是否允许再申购"
											>
												<Form.Item
													name="f110"
												>
													<Radio.Group  buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="是">是</Radio.Button>
														<Radio.Button value="否">否</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Descriptions.Item> */}
											<Descriptions.Item
												label="投顾转份额比例"
											>
												<Form.Item
													name="f189"
												>
													<Input disabled={!isEdit} bordered={false} />
												</Form.Item>
											</Descriptions.Item>


											<Descriptions.Item
												label="投资顾问作为委托人"
												span={2}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f111"
														style={{ width: "20%", display: "inline-block" }}

													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f111"}/>
													}
												</div>
												<Form.Item
													name="f112"
													style={{ width: "50%", display: "inline-block" }}
												>
													<Input disabled={!isEdit} placeholder="请填写投资顾问认购合同编号" bordered={false} />
												</Form.Item>
											</Descriptions.Item>
											{/* <Descriptions.Item
												label="填写投资顾问认购合同编号"
											>
												
											</Descriptions.Item> */}
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<span>申赎交易参数</span>}
							>
								<Row gutter={[5, 5]}>
									<Col span={24}>
										<Descriptions
											bordered
											size="middle"
											column={2}
										>
											<Descriptions.Item
												label="认/申购金额检验方式"
												contentStyle={{ width: 400 }}
												span={1}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f113"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="总金额(含费用)">总金额(含费用)</Radio.Button>
															<Radio.Button value="净额（不含费用）">净额（不含费用）</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f113"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="赎回单位"
												contentStyle={{ width: 400 }}
												span={1}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f114"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="份额赎回">份额赎回</Radio.Button>
															<Radio.Button value="金额赎回">金额赎回</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f114"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												span={1}
												label="赎回顺序"
												contentStyle={{ width: 400 }}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f115"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="先进先出">先进先出</Radio.Button>
															<Radio.Button value="后进先出">后进先出</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f115"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												span={1}
												label="最低持有金额判断方式"
												contentStyle={{ width: 400 }}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f190"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="按上一开放日">按上一开放日</Radio.Button>
															<Radio.Button value="按本次开放日">按本次开放日</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f190"}/>
													}
												</div>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
								<Row gutter={[8, 8]} className="self_table">
									<Col span={24}>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">认申购参数</div>
											</Col>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">个人</div>
											</Col>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">机构/产品</div>
											</Col>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">赎回参数</div>
											</Col>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">个人</div>
											</Col>
											<Col span={4}>
												<div className="trade_param_header trade_param_title">机构/产品</div>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔最低认购/首次申购金额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f116"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f128"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">单笔最低赎回单位</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f123"
												>
													<Input placeholder="请在此处填写" disabled={!isEdit} bordered={false} />
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f135"
												>
													<Input placeholder="请在此处填写" disabled={!isEdit} bordered={false} />
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔最高认购/首次申购金额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f117"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f129"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">单笔最高赎回单位</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f124"
												>
													<Input disabled={!isEdit} bordered={false} placeholder="请在此处填写"/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f136"
												>
													<Input disabled={!isEdit} bordered={false} placeholder="请在此处填写"/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">累计购买最高规格</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f118"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f130"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											{/* <Col span={4}>
												<div className="trade_param_title">单笔赎回增量基数</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f125"
												>
													<Input 
														disabled={!isEdit}
														bordered={false}
													/>
												</Form.Item>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f137"
												>
													<Input 
														disabled={!isEdit}
														bordered={false}
													/>
												</Form.Item>
											</Col> */}
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔认购/首次申购增量基数</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f119"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f131"
												>
													<Input
														placeholder="请在此处填写"
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">最低持有金额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f126"
												>
													<Input
														disabled={!isEdit}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f138"
												>
													<Input
														disabled={!isEdit}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔最低申购金额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f120"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f132"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">最低持有份额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f127"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f139"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔最高申购金额</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f121"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f133"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">少于最低持有处理方式</div>
											</Col>
											<Col span={8}>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f183"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="全部赎回">全部赎回</Radio.Button>
															<Radio.Button value="赎回失败">赎回失败</Radio.Button>
															<Radio.Button value="保留最低持有">保留最低持有</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f183"}/>
													}
												</div>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">单笔申购金额增量基数</div>
											</Col>
											<Col span={4}>
												<Form.Item
													name="f122"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<Form.Item
													name="f134"
												>
													<Input
														disabled={!isEdit} style={{ width: '100%' }}
														bordered={false}
														placeholder="请在此处填写"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={12}></Col>
											{/*
											<Col span={4}>
												<div className="trade_param_title">少于最低持有处理方式</div>
											</Col>
											<Col span={8}>
												<Form.Item
													name="f146"
												>
													<Radio.Group buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="全部赎回">全部赎回</Radio.Button>
														<Radio.Button value="赎回失败">赎回失败</Radio.Button>
														<Radio.Button value="保留最低持有">保留最低持有</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
										*/}
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={4}>
												<div className="trade_param_title">巨额赎回比例</div>
											</Col>
											<Col span={8}>
												<Form.Item
													name="f141"
												>
													<Input
														disabled={!isEdit}
														bordered={false}
														placeholder="请填写巨额赎回比例"
													/>
												</Form.Item>
												<Divider style={{ margin: "0" }} />
											</Col>
											<Col span={4}>
												<div className="trade_param_title">巨额赎回处理方式</div>
											</Col>
											<Col span={8}>
												<div className="highlight">
													<Form.Item
														name="f140"
													>
														<Select
															mode="multiple"
															disabled={!isEdit}
															placeholder={"请选择巨额赎回处理方式"}
															getPopupContainer={triggerNode => triggerNode.parentNode}
														>
															<Select.Option value="全部赎回">全部赎回</Select.Option>
															<Select.Option value="部分顺延赎回">部分顺延赎回</Select.Option>
															<Select.Option value="顺延支付">顺延支付</Select.Option>
														</Select>
													</Form.Item>
													<Divider style={{ margin: "0" }} />
												</div>
											</Col>
										</Row>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<span>封闭期</span>}
								id="fbq_card"
							>
								<Row gutter={[8, 8]}>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={3}
										>
											<Descriptions.Item
												label="封闭期允许交易类型"
												span={1.5}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f142"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="全部不允许">全部不允许</Radio.Button>
															<Radio.Button value="申购">申购</Radio.Button>
															<Radio.Button value="赎回">赎回</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f142"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="封闭期结束日包含关系"
												span={1.5}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f143"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="包含">包含</Radio.Button>
															<Radio.Button value="不包含">不包含</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f143"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="封闭方式"
												contentStyle={{ width: 500 }}
												span={1.5}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f144"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit} onChange={this.changeCloseType}>
															<Radio.Button value="按产品成立日">按产品成立日</Radio.Button>
															<Radio.Button value="按首笔份额登记日">按首笔份额登记日</Radio.Button>
															<Radio.Button value="单笔份额登记日">单笔份额登记日</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f144"}/>
													}
												</div>
											</Descriptions.Item>
											{
												closeType == '按产品成立日' ?
													<Descriptions.Item
														label="封闭期限描述"
														contentStyle={{ width: 400 }}
														span={1.5}
													>
														<Form.Item
															name="f200"
														>
															<Input
																placeholder="可填写封闭期限描述"
																disabled={!isEdit}
																style={{ width: '100%' }}
																bordered={false}
															/>
															{/* <DatePicker 
															locale={locale} disabled={!isEdit} style={{width:'100%'}} 
															getPopupContainer={() => document.getElementById('fbq_card')}
														/> */}
														</Form.Item>
													</Descriptions.Item> :
													<Descriptions.Item
														label="封闭期单位"
														contentStyle={{ width: 400 }}
														span={1.5}
													>
														<div style={{ display: 'flex' }}>

															<Form.Item
																name="f147"
															>
																<Radio.Group buttonStyle="solid" disabled={!isEdit}>
																	<Radio.Button value="日">日</Radio.Button>
																	<Radio.Button value="月">月</Radio.Button>
																	<Radio.Button value="年">年</Radio.Button>
																	<Radio.Button value="开放日">开放日</Radio.Button>
																</Radio.Group>
															</Form.Item>
															{
																isEdit && <Replacement formRef={this.props.formRef} subscript={"f147"}/>
															}
														</div>
													</Descriptions.Item>
											}{
												closeType == '按产品成立日' ?
													<Descriptions.Item
														label="封闭期结束日"
														span={1.5}
														contentStyle={{ width: 400 }}
													>
														<Form.Item
															name="f146"
														>
															<DatePicker
																locale={locale} disabled={!isEdit}
																style={{ width: '100%' }}
																getPopupContainer={() => document.getElementById('fbq_card')}
															/>
														</Form.Item>
													</Descriptions.Item> :
													<Descriptions.Item
														label="封闭期时长"
														span={1.5}
														contentStyle={{ width: 400 }}
													>
														<Form.Item
															name="f148"
														>
															<Input disabled={!isEdit} bordered={false} />
														</Form.Item>
													</Descriptions.Item>
											}
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<span>费用信息</span>}
							>
								<Row gutter={[8, 8]} className="self_table">
									<Col span={24}>
										<Row gutter={[2, 2]}>
											<Col span={3}>
												<div className="trade_param_header trade_param_title">
													单位:金额(人民币元) 份额(份)
												</div>
											</Col>
											<Col span={7}>
												<div className="trade_param_header trade_param_title">
													认购费
												</div>
											</Col>
											<Col span={7}>
												<div className="trade_param_header trade_param_title">
													申购费（含首次申购）
												</div>
											</Col>
											<Col span={7}>
												<div className="trade_param_header trade_param_title">
													赎回费
												</div>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={3}>
												<div className="trade_param_title">
													认购费收取方式
												</div>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f149"
												>
													<Radio.Group buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="价内">价内</Radio.Button>
														<Radio.Button value="价外">价外</Radio.Button>
														<Radio.Button value="无">无</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f150"
												>
													<Radio.Group buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="价内">价内</Radio.Button>
														<Radio.Button value="价外">价外</Radio.Button>
														<Radio.Button value="无">无</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f151"
												>
													<Radio.Group buttonStyle="solid" disabled={!isEdit}>
														<Radio.Button value="价内">价内</Radio.Button>
														<Radio.Button value="价外">价外</Radio.Button>
														<Radio.Button value="无">无</Radio.Button>
													</Radio.Group>
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={3}>
												<div className="trade_param_title">
													费率（%）/费用（元）
												</div>
											</Col>
											<Col span={7}>
												<Space style={{ width: '100%' }}>
													<Form.Item
														name="f152"
														label="个人"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
													<Form.Item
														name="f153"
														label="机构产品"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
												</Space>
											</Col>
											<Col span={7}>
												<Space style={{ width: '100%' }}>
													<Form.Item
														name="f154"
														label="个人"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
													<Form.Item
														name="f155"
														label="机构产品"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
												</Space>
											</Col>
											<Col span={7}>
												<Space style={{ width: '100%' }}>
													<Form.Item
														name="f156"
														label="个人"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
													<Form.Item
														name="f157"
														label="机构产品"
													>
														<Input disabled={!isEdit} style={{ width: '100%' }} />
													</Form.Item>
												</Space>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={3}>
												<div className="trade_param_title">收费公式</div>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f158"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f159"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f160"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={[2, 2]}>
											<Col span={3}>
												<div className="trade_param_title">是否涉及费用减免/折扣</div>
											</Col>
											<Col span={7}>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f161"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f161"}/>
													}
												</div>
											</Col>
											<Col span={7}>
												<div className="trade_param_title">费率折扣类型</div>
											</Col>
											<Col span={7}>
												<Form.Item
													name="f162"
												>
													<Select
														mode="multiple"
														disabled={!isEdit}
														placeholder={"点击下拉选择"}
														getPopupContainer={triggerNode => triggerNode.parentNode}
													>
														<Select.Option value="认购费">认购费</Select.Option>
														<Select.Option value="申购费">申购费</Select.Option>
														<Select.Option value="赎回费">赎回费</Select.Option>
													</Select>
												</Form.Item>
											</Col>
										</Row>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
					<Row
						gutter={[8, 8]}
						style={{ width: '100%' }}
					>
						<Col span={24}>
							<Card
								title={<span>单人单笔浮动费用计提</span>}
								// title={<span>单人单笔浮动费用计提标准计提频率和计提公式</span>}
								id="Cost_provision"
							>
								<Row gutter={[8, 8]}>
									<Col span={24}>
										<Descriptions
											size="middle"
											bordered
											column={3}
										>
											<Descriptions.Item
												label="首个业绩基准"
												contentStyle={{ width: 400 }}
												span={1.5}
											>
												<Form.Item
													name="f191"
												>
													<Input disabled={!isEdit} />
												</Form.Item>
											</Descriptions.Item>
											<Descriptions.Item
												contentStyle={{ width: 400 }}
												label="是否涉及调整/加权"
												span={1.5}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f192"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="是">是</Radio.Button>
															<Radio.Button value="否">否</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f192"}/>
													}
												</div>
											</Descriptions.Item>
											<Descriptions.Item
												label="浮动费用计提时点"
												contentStyle={{ width: 400 }}
												span={3}
											>
												<div style={{ display: 'flex' }}>

													<Form.Item
														name="f193"
													>
														<Radio.Group buttonStyle="solid" disabled={!isEdit}>
															<Radio.Button value="赎回">赎回</Radio.Button>
															<Radio.Button value="分红">分红</Radio.Button>
															<Radio.Button value="终止">终止</Radio.Button>
															<Radio.Button value="超额收益核算日">超额收益核算日</Radio.Button>
														</Radio.Group>
													</Form.Item>
													{
														isEdit && <Replacement formRef={this.props.formRef} subscript={"f193"}/>
													}
												</div>
											</Descriptions.Item>

											<Descriptions.Item
												// label="单人单笔浮动费用计提"
												label="单人单笔浮动费用计提标准计提频率和计提公式"
												contentStyle={{ width: 400 }}
												span={3}
											>
												<Form.Item
													name="f194"
												>
													<Input.TextArea
														disabled={!isEdit}
														bordered={false}
														autoSize={{ minRows: 10, maxRows: 18 }}
													/>
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>


					{/* <Row 
						gutter={[8,8]}
						style={{width: '100%'}}
					>
						<Col span={24}>
							<Card
								title={<span>业绩报酬</span>}
							>
								<Row gutter={[8,8]} className="self_table">
									<Col span={24}>
										<Descriptions
											bordered
											size="middle"
											column={1}
										>
											<Descriptions.Item
												label="单人/单笔浮动费用计提标准、集体频率和计提公式"
												labelStyle={{width: '20%'}}
												contentStyle={{width: '80%'}}
											>
												<Form.Item
													name="f163"
												>
													<Input.TextArea disabled={!isEdit}/>
												</Form.Item>
											</Descriptions.Item>
										</Descriptions>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
					<Row 
						gutter={[8,8]}
						style={{width: '100%'}}
					>
						<Col span={24}>
							<Card
								title={<span>CRM/APP定制项</span>}
							>
								<table className="table_info">
									<tbody>
									<tr>
										<td className="table_title"></td>
										<td className="table_title"></td>
										<td className="table_title">个人</td>
										<td className="table_title">机构/产品</td>
										<td className="table_title">是否允许理财资金认购</td>
										<td>
											<Form.Item
												name="f176"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td rowSpan={3} className="table_title">重复购买</td>
										<td className="table_title">是否允许</td>
										<td>
											<Form.Item
												name="f164"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f165"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td className="table_title">是否允许信惠赎回转认购</td>
										<td>
											<Form.Item
												name="f184"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td className="table_title">是否需要审批</td>
										<td>
											<Form.Item
												name="f166"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f167"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td className="table_title">预约交易是否需要逐笔审批</td>
										<td>
											<Form.Item
												name="f177"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td className="table_title">计数策略</td>
										<td>
											<Form.Item
												name="f168"
											>
												<Input disabled={!isEdit} />
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f169"
											>
												<Input disabled={!isEdit} />
											</Form.Item>
										</td>
										<td className="table_title">双录话术配置定制</td>
										<td>
											<Form.Item
												name="f178"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td rowSpan={3} className="table_title">签署页是否需要定制</td>
										<td className="table_title">认购</td>
										<td>
											<Form.Item
												name="f170"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f171"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td className="table_title">风险测评是否需要定制</td>
										<td>
											<Form.Item
												name="f179"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td className="table_title">申购</td>
										<td>
											<Form.Item
												name="f172"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f173"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td className="table_title" rowSpan={2}>财富APP特殊展示项</td>
										<td>
											<Form.Item
												name="f180"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="巨额赎回选择">巨额赎回选择</Radio.Button>
													<Radio.Button value="浮动业绩报酬">浮动业绩报酬</Radio.Button>
													<Radio.Button value="累计净值">累计净值</Radio.Button>
													<Radio.Button value="其他">其他</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
									</tr>
									<tr>
										<td className="table_title">赎回</td>
										<td>
											<Form.Item
												name="f174"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f181"
											>
												<Radio.Group buttonStyle="solid" disabled={!isEdit}>
													<Radio.Button value="是">是</Radio.Button>
													<Radio.Button value="否">否</Radio.Button>
												</Radio.Group>
											</Form.Item>
										</td>
										<td>
											<Form.Item
												name="f191"
											>
												<Input placeholder="其它详细说明" disabled={!isEdit}/>
											</Form.Item>
										</td>
									</tr>
									</tbody>
								</table>
							</Card>
						</Col>
					</Row> */}
					{/*
				</Form>
				*/}
				</Spin>
			</div>
		)
	}
}

export default TAInfo;


// WEBPACK FOOTER //
// app/components/customPage/project-manager/Pages/TAInfo.jsx